import { CommonEnums } from '../common.enums';
import { Param } from './domain/param';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

export class Usr_Log {
    obj_Id: number;
    usr_Id: number;
    obj_Cd: string;
    action_Cd: string;
    fldr_Id: number;
    login_Id: string;
    createdDt: Date;
    objNm: string;
    fldrNm: string;
    dbTyp_Id: number;
    localFlag: string;
    reusableFlag: string;
    valid_Cd: string;
    dbTyp_Nm: string;
    imageUrl: string;
    baseLink: string;
    params: Array<Param>;
    link: string;

    // Extra added..
    nm: string;
    objectName: string;
    change_Ind: string;
    isOpened: boolean;
    mode_Ind: string;
    url: string;
    valid_Msg: string;

    constructor() {
        this.setDefaults();
    }

    setDefaults() {
        this.obj_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.usr_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.obj_Cd = CommonEnums.defaults.DEFAULT_EMPTY_STRING;
        this.action_Cd = CommonEnums.defaults.DEFAULT_EMPTY_STRING;
        this.fldr_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.login_Id = CommonEnums.defaults.DEFAULT_EMPTY_STRING;
        this.createdDt = new Date();
        this.objNm = CommonEnums.defaults.DEFAULT_EMPTY_STRING;
        this.fldrNm = CommonEnums.defaults.DEFAULT_EMPTY_STRING;
        this.dbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.localFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.reusableFlag = CommonEnums.reusableFlag.NO;
        this.valid_Cd = CommonEnums.defaults.VALID_CD;
        this.dbTyp_Nm = CommonEnums.defaults.DEFAULT_EMPTY_STRING;
        this.imageUrl = CommonEnums.defaults.DEFAULT_EMPTY_STRING;
        this.baseLink = CommonEnums.defaults.DEFAULT_EMPTY_STRING;
        this.link = CommonEnums.defaults.DEFAULT_EMPTY_STRING;

        this.params = new Array<Param>();

        this.nm = "";
        this.objectName = "";
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.isOpened = false;
        this.mode_Ind = CommonEnums.mode_Ind.WRITE;
        this.url = "";
        this.valid_Msg = "";
    }

    static parse(usr_LogTmp: Usr_Log): Usr_Log {
        let usr_Log: Usr_Log = new Usr_Log();
        usr_Log.copyFrom(usr_LogTmp);
        return usr_Log;
    }

    copy(): Usr_Log {
        let usr_LogTmp: Usr_Log = new Usr_Log();

        usr_LogTmp.obj_Id = this.obj_Id;
        usr_LogTmp.usr_Id = this.usr_Id;
        usr_LogTmp.obj_Cd = this.obj_Cd;
        usr_LogTmp.action_Cd = this.action_Cd;
        usr_LogTmp.fldr_Id = this.fldr_Id;
        usr_LogTmp.login_Id = this.login_Id;
        usr_LogTmp.createdDt = this.createdDt;
        usr_LogTmp.objNm = this.objNm;
        usr_LogTmp.fldrNm = this.fldrNm;
        usr_LogTmp.dbTyp_Id = this.dbTyp_Id;
        usr_LogTmp.localFlag = this.localFlag;
        usr_LogTmp.reusableFlag = this.reusableFlag;
        usr_LogTmp.valid_Cd = this.valid_Cd;
        usr_LogTmp.dbTyp_Nm = this.dbTyp_Nm;
        usr_LogTmp.baseLink = this.baseLink;
        usr_LogTmp.params = this.params;

        usr_LogTmp.imageUrl = this.imageUrl;
        usr_LogTmp.link = this.link;

        usr_LogTmp.nm = this.nm;
        usr_LogTmp.objectName = this.objectName;
        usr_LogTmp.change_Ind = this.change_Ind;
        usr_LogTmp.isOpened = this.isOpened;
        usr_LogTmp.mode_Ind = this.mode_Ind;
        usr_LogTmp.url = this.url;
        usr_LogTmp.valid_Msg = this.valid_Msg;

        return usr_LogTmp;
    }

    copyFrom(usr_LogTmp: Usr_Log): void {
        this.obj_Id = usr_LogTmp.obj_Id;
        this.usr_Id = usr_LogTmp.usr_Id;
        this.obj_Cd = usr_LogTmp.obj_Cd;
        this.action_Cd = usr_LogTmp.action_Cd;
        this.fldr_Id = usr_LogTmp.fldr_Id;
        this.login_Id = usr_LogTmp.login_Id;
        this.createdDt = usr_LogTmp.createdDt;
        this.objNm = usr_LogTmp.objNm;
        this.fldrNm = usr_LogTmp.fldrNm;
        this.dbTyp_Id = usr_LogTmp.dbTyp_Id;
        this.localFlag = usr_LogTmp.localFlag;
        this.reusableFlag = usr_LogTmp.reusableFlag;
        this.valid_Cd = usr_LogTmp.valid_Cd;
        this.dbTyp_Nm = usr_LogTmp.dbTyp_Nm;
        this.baseLink = usr_LogTmp.baseLink;
        this.params = usr_LogTmp.params;
        this.link = usr_LogTmp.link;
        this.imageUrl = usr_LogTmp.imageUrl;

        this.nm = usr_LogTmp.nm;
        this.objectName = usr_LogTmp.objectName;
        this.change_Ind = usr_LogTmp.change_Ind;
        this.isOpened = usr_LogTmp.isOpened;
        this.mode_Ind = usr_LogTmp.mode_Ind;
        this.url = usr_LogTmp.url;
        this.valid_Msg = usr_LogTmp.valid_Msg;
    }

    compare(usr_logTmp: Usr_Log): string {
        let usr_logString: string = this.toString(false);
        let usr_logTmpString: string = usr_logTmp.toString(false);

        if (usr_logString != usr_logTmpString) {
            return usr_logString + ', ' + usr_logTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Org [obj_Id=" + this.obj_Id + ", fldr_Id=" + this.fldr_Id +
            ", login_Id=" + this.login_Id + ", usr_Id=" + this.usr_Id +
            ", obj_Cd =" + this.obj_Cd + ",action_Cd =" + this.action_Cd +
            ", createdDt =" + this.createdDt;

        if (isNotCompare) {
            str += ", objNm=" + this.objNm +
                ", fldrNm=" + this.fldrNm +
                ", dbTyp_Id=" + this.dbTyp_Id +
                ", localFlag=" + this.localFlag +
                ", reusableFlag=" + this.reusableFlag +
                ", valid_Cd=" + this.valid_Cd +
                ", dbTyp_Nm=" + this.dbTyp_Nm +
                ", imageUrl=" + this.imageUrl +
                ", baseLink=" + this.baseLink +
                ", params=" + this.params +
                ", link =" + this.link;
        }

        str += ']';
        return str;
    }
}